import { FONT_COLOURS } from '@belong/themes';
import { Document, Entry, FontColoursKey, IElementFeatureRow } from '@belong/types';
import { assertContentType } from '../../helpers/assertContentType';
import { FSystemIcon } from './elementSystemIcon.factory';

export interface IEntryElementFeatureRow {
  identifier: string;
  description?: Document;
  descriptionColor?: FontColoursKey | string;
  icon: Entry<any>;
  heading?: string;
}

export const isEntryElementFeatureRow = (entry: Entry<any>): entry is Entry<IEntryElementFeatureRow> =>
  entry.sys.contentType.sys.id === 'elementFeatureRow';

export const FElementFeatureRow = (data: Entry<IEntryElementFeatureRow>): IElementFeatureRow => {
  assertContentType(data, 'elementFeatureRow');
  const { description, descriptionColor, heading, icon } = data.fields;

  return {
    id: data.fields.identifier,
    description,
    descriptionColor: descriptionColor && (FONT_COLOURS[descriptionColor] || descriptionColor),
    heading,
    icon: icon && FSystemIcon(icon)
  };
};
